export const SET_CREATE_OR_EDIT_FIELD_TYPE = 'SET_CREATE_OR_EDIT_FIELD_TYPE';

export function setCreateOrEditFieldType(fieldType) {
  return {
    type: SET_CREATE_OR_EDIT_FIELD_TYPE,
    fieldType,
  };
}
